var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseError = function SvgCloseError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C12218",
    d: "M.529.529c.26-.26.682-.26.942 0L5 4.057 8.529.53a.667.667 0 0 1 .942.942L5.943 5 9.47 8.529a.667.667 0 1 1-.942.942L5 5.943 1.471 9.47A.667.667 0 0 1 .53 8.53L4.057 5 .53 1.471a.667.667 0 0 1 0-.942"
  })));
};
export default SvgCloseError;